import type { ApplicationDomain } from "~/models/dto";
import { useRequiredContext } from "~/tools/use-required-context";

import { ApplicationDomainContext } from "./_context";

export const useApplicationDomain = (): ApplicationDomain =>
	useRequiredContext(ApplicationDomainContext, { providerName: "ApplicationDomainContext" });
